import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { rolesApi as r } from "@maat/api-main";
//#region src/workspaces/useDeleteRoleMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.deleteRole(e),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.roles() }), i.invalidateQueries({ queryKey: e.role(n) });
		}
	});
};
//#endregion
export { i as useDeleteRoleMutation };
